import React from 'react';

const UploadProgress = ({ isVisible, progress, fileName, currentFile, totalFiles, uploadSpeed, estimatedTime }) => {
  if (!isVisible) return null;

  const formatSpeed = (mbps) => {
    if (!mbps || mbps === 0) return '-- MB/s';
    return `${mbps.toFixed(2)} MB/s`;
  };

  const formatTime = (seconds) => {
    if (!seconds || seconds === 0 || !isFinite(seconds)) return 'Calculating...';
    if (seconds < 60) return `${Math.ceil(seconds)}s`;
    const minutes = Math.floor(seconds / 60);
    const secs = Math.ceil(seconds % 60);
    return `${minutes}m ${secs}s`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 bg-black/70 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-4 sm:p-6 md:p-8 animate-slide-up">
        {/* Icon */}
        <div className="text-center mb-3 sm:mb-4 md:mb-6">
          <div className="inline-block animate-pulse">
            <span className="text-4xl sm:text-5xl md:text-6xl">📤</span>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-center text-gray-800 mb-1 sm:mb-2">
          Uploading Photos
        </h3>

        {/* File Counter */}
        {totalFiles > 0 && (
          <p className="text-center text-xs sm:text-sm md:text-base text-gray-600 mb-1 sm:mb-2">
            File {currentFile} of {totalFiles}
          </p>
        )}

        {/* Current File Name */}
        {fileName && (
          <p className="text-center text-[10px] sm:text-xs md:text-sm text-gray-500 mb-2 sm:mb-3 md:mb-4 truncate px-2 sm:px-4">
            {fileName}
          </p>
        )}

        {/* Progress Bar */}
        <div className="space-y-1 sm:space-y-2 mb-2 sm:mb-3 md:mb-4">
          <div className="w-full bg-gray-200 rounded-full h-3 sm:h-4 overflow-hidden">
            <div
              className="bg-gradient-to-r from-primary-500 to-primary-600 h-full rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            >
              <div className="h-full w-full bg-white/20 animate-pulse"></div>
            </div>
          </div>

          {/* Percentage */}
          <p className="text-center text-base sm:text-lg font-semibold text-primary-600">
            {progress}%
          </p>
        </div>

        {/* Speed and Time Stats */}
        <div className="bg-gray-50 rounded-lg p-2 sm:p-3 md:p-4 space-y-1 sm:space-y-2 mb-2 sm:mb-3 md:mb-4">
          <div className="flex justify-between text-xs sm:text-sm">
            <span className="text-gray-600">Speed:</span>
            <span className="font-semibold text-gray-800">{formatSpeed(uploadSpeed)}</span>
          </div>
          <div className="flex justify-between text-xs sm:text-sm">
            <span className="text-gray-600">Time Remaining:</span>
            <span className="font-semibold text-gray-800">{formatTime(estimatedTime)}</span>
          </div>
        </div>

        {/* Message */}
        <p className="text-center text-xs sm:text-sm text-gray-500">
          Please don't close this window...
        </p>
      </div>
    </div>
  );
};

export default UploadProgress;

